import * as LocationsAssignment from './locationsAssignment';
import * as LocationEditor from './locationEditor';
import * as Allocations from './allocations';
import * as Warehouse from './warehouses';
import * as Locations from './locations';

const Actions = {
  ...Warehouse,
  ...Allocations,
  ...Locations,
  ...LocationsAssignment,
  ...LocationEditor,
};

export default Actions;
